import { clientInformation } from "@discovery/common-dplus/lib/device-info";
import { envBrowser } from "@discovery/maestro-env-browser";
import * as E from "fp-ts/Either";
import * as App from "@discovery/maestro";
import { cn } from "@discovery/classnames";
import * as M from "@discovery/prelude/lib/data/maybe";
import { pushFavoriteOrWatchListEvents } from "@discovery/common-dplus/lib/adobe";
import * as styles from "../kebab-menu/styles.css";
import { Typography, Tags, HeaderVariants } from "../../atoms/typography";
import * as Favorite from "@discovery/sonic-api-ng/lib/api/users/favorites";
import { shareHandler, SHARE_TYPE } from "../../../utils/share";
import { config } from "@discovery/common-dplus/lib/utils/config-types";
import { blueshiftFavorite } from "@discovery/common-dplus/lib/blueshift";
export const KebabMenuForUnFavorites = ({ items, type, read, removeFromfavorites, closekebabMenu, id, route, descriptionM, image, name, category, userId, }) => {
    const removeShowsFromFavorites = (id) => {
        closekebabMenu();
        const postRequest = Favorite.Endpoints.deleteFavorite(id, "shows");
        read &&
            App.run(postRequest)(Object.assign(Object.assign(Object.assign({}, envBrowser), read), { clientInformation: clientInformation })).then(E.fold((_exception) => {
                /* handle exception here */
            }, () => {
                removeFromfavorites && removeFromfavorites(id);
                blueshiftFavorite(userId, id, "delete", category, name ? name : "");
                pushFavoriteOrWatchListEvents("remove favorites", "remove favorites", window.location.href, window.location.origin + route);
            }));
    };
    const kebabMenuItemHandlerVideos = (itemId, name, route, videoId, descriptionM, image) => {
        const shareURL = config.shareBaseURL + route;
        switch (itemId) {
            case "UNLIKE":
                return removeShowsFromFavorites(videoId);
            case "SHARE":
                return shareHandler(SHARE_TYPE.SHARE, image, descriptionM, name, shareURL);
        }
    };
    return (React.createElement("div", { className: cn(styles.wrapper, { [styles.showWrapper]: type === "show" }) }, items &&
        items.map((item, index) => {
            return (React.createElement("div", { className: styles.onHover, key: index, onClick: () => {
                    kebabMenuItemHandlerVideos(item.id, name, route, id, descriptionM, image);
                } },
                React.createElement(Typography, { classNameM: M.of(styles.listItems), variant: HeaderVariants.headingSix, tag: Tags.h6 },
                    React.createElement(React.Fragment, null, item.label))));
        })));
};

